module.exports = __webpack_public_path__ + "static/media/german_panzer_120x120.3227df8e.png";